import { ONE_GB, ONE_MB } from '../shared.constants';

export enum SizeBucket {
  UNDER_100_MB = '<100MB',
  MB_100_TO_GB_1 = '100MB-1GB',
  GB_1_TO_2 = '1-2GB',
  GB_2_TO_10 = '2-10GB',
  GB_10_TO_50 = '10-50GB',
  OVER_50_GB = '>50GB',
}

/**
 * Boundaries bracket the 2 GB streaming minimum and the range where staged downloads start hitting the
 * origin-storage quota. Low cardinality on purpose — this is a Mixpanel dimension, not a display string.
 */
export function sizeBucket(bytes: number): SizeBucket {
  if (!Number.isFinite(bytes) || bytes < 100 * ONE_MB) {
    return SizeBucket.UNDER_100_MB;
  }
  if (bytes < ONE_GB) {
    return SizeBucket.MB_100_TO_GB_1;
  }
  if (bytes < 2 * ONE_GB) {
    return SizeBucket.GB_1_TO_2;
  }
  if (bytes < 10 * ONE_GB) {
    return SizeBucket.GB_2_TO_10;
  }
  if (bytes < 50 * ONE_GB) {
    return SizeBucket.GB_10_TO_50;
  }
  return SizeBucket.OVER_50_GB;
}
